import React, {useEffect, useRef, useState} from "react";
import './pagePayement.css'
import InputForm from "../../../components/inputForm/InputForm";
import DOMPurify from "dompurify";
import { getPurifyMail } from "../../../components/types/types";
import MaskBackground from "../../../components/maskBackground/maskBackground";
import { TfiClose } from "react-icons/tfi";

interface PagePayementProps {
    validPage:(id:number) => void,
    token:string,
    emailStart:string,
    addressStart:string,
    firstnameStart:string,
    lastnameStart:string,
    phoneStart:string,
    cityStart: string,
    postalCodeStart:number,
    denominationStart:string,
}

const PagePayement:React.FC<PagePayementProps> = ({validPage,token,emailStart,cityStart,postalCodeStart,addressStart,firstnameStart,lastnameStart,phoneStart,denominationStart}) => {


    const [address,setAddress] = useState(addressStart)
    const [city,setCity] = useState(cityStart)
    const [currentCode,setCurrentCode] = useState(postalCodeStart.toString())
    const [postalCode,setPostalCode] = useState(postalCodeStart)
    const [firstName,setFirstName] = useState(firstnameStart)
    const [lastName,setLastName] = useState(lastnameStart)
    const [phone,setPhone] = useState(phoneStart)
    const [denomination,setDenomination] = useState(denominationStart)
    const [showGoPayment,setShowGoPayment] = useState(false)


    const [validDenomination,setValidDenomination] = useState(true)
    const [validPhone,setValidPhone] = useState(true)
    const [validAddress,setValidAddress] = useState(true)
    const [validCity,setValidCity] = useState(true)
    const [validFirstName,setValidFirstName] = useState(true)
    const [validLastName,setValidLastName] = useState(true)
    const [validPostalCode,setValidPostalCode] = useState(true)

    const [isPossibleSend,setIsPossibleSend] = useState(true)

    useEffect(() => {
        setTimeout(() => { window.scrollTo(0,0)},10)
    },[])

    const formatPhoneNumber = (value: string) => {
        const cleaned = value.replace(/\D+/g, '');
        return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ');
        };
    const handleChangePhone = (event:React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value
        if (/^[0-9 ]*$/.test(value)) {
            if (value.length < 15) {
                const formattedValue = formatPhoneNumber(value);
                setPhone(formattedValue);
            }
        }
        };
    const handleBlurPhone = (event:React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (/^[0-9 ]*$/.test(value)) {
            if (value.length >= 15) {
                setPhone('');
            }
        }
    }

    const handleSubmit = async () => {
        
        if(lastName.length < 2 || lastName.length > 50) setValidLastName(false)
        else setValidLastName(true)
        if(firstName.length < 2 || firstName.length > 50) setValidFirstName(false)
        else setValidFirstName(true)



        if(denomination.length < 2 || denomination.length > 120) setValidDenomination(false)
        else setValidDenomination(true)
        if(address.length < 2 || address.length > 120) setValidAddress(false)
        else setValidAddress(true)
        if(city.length < 2 || city.length > 120) setValidCity(false)
        else setValidCity(true)
        const formatPhone = phone.replace(/\s+/g, '');
        if(formatPhone.length !== 10) setValidPhone(false)
        else setValidPhone(true)

        if(postalCode< 1000 || postalCode > 98890 || postalCode.toString().length < 5) setValidPostalCode(false)
        else setValidPostalCode(true)

        if((denomination.length <= 120 && denomination.length >= 2) &&  (lastName.length <= 50 && lastName.length >= 2) && (firstName.length <= 50 && firstName.length >= 2) &&  formatPhone.length === 10 && (address.length <= 120 && address.length >= 2) && (city.length <= 120 && city.length >= 2) && (postalCode>= 1000 && postalCode <= 98890) && isPossibleSend)  {
            setIsPossibleSend(false)
            const cleanName = DOMPurify.sanitize(lastName)
            const cleanAddress= DOMPurify.sanitize(address)
            const cleancity= DOMPurify.sanitize(city)
            const cleanPhone = DOMPurify.sanitize(formatPhone)
            const cleanFirstName =  DOMPurify.sanitize(firstName)
            const cleanMail = getPurifyMail(emailStart)
            const cleanPostalCode=  DOMPurify.sanitize(postalCode.toString())
            const cleanDenomination = DOMPurify.sanitize(denomination)
            
            try {
               
                const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/formulaire_hmac`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        denomination:cleanDenomination,
                        lastName: cleanName,
                        firstName: cleanFirstName,
                        phone: cleanPhone,
                        address:cleanAddress,
                        email:cleanMail,
                        token:token,
                        city:cleancity,
                        zipcode:cleanPostalCode
                    })
                });


                if (response.ok) {
                    const htmlContent = await response.text();
                    const formContainer = document.createElement('div');
                    formContainer.innerHTML = htmlContent;

                    const form = formContainer.querySelector('form');
                    if (form) {
                        form.style.display = 'none'; 
                        document.body.appendChild(form);  


                        form.submit();
                        
                        await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/registerResto`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                token: token,
                            })
                        });
                    }
                } else {
                    const errorData = await response.json();
                    if (errorData.code === 'TOKEN_USED') {
                        alert("Inscription déjà terminée ou expirée. Redirection vers l’accueil.");
                        window.location.href = "/";
                    }
                    else alert("Erreur lors du paiement. Veuillez réessayer.");
                    setTimeout(() => {
                        setIsPossibleSend(true)
                    },3000)
                    
                } 
            } catch (error) {
                console.error("Erreur lors de la requête:", error);
                setTimeout(() => {
                    setIsPossibleSend(true)
                },3000)
                alert("Une erreur est survenue. Veuillez réessayer.");
            }
        }
        else {
            setIsPossibleSend(true)
        }
    };
    return (
        <div className="pagePayement secondaryBack">
            <div className="mainCorp" >
                <div className="leftPart" >
                    <div className="containerDobbleInput columnPhone">
                        <InputForm value={lastName} setValue={setLastName} PrimaryText="Nom" SecondaryText="Nom incorrect"  idInput="inputNamePayment" placeHolder="Nom" maxLength={30} valid={validLastName} setValid={setValidLastName}/>
                        <InputForm value={firstName} setValue={setFirstName} PrimaryText="Prénom" SecondaryText="Prénom incorrect"  idInput="inputFirstNamePayment" placeHolder="Prénom" maxLength={30} valid={validFirstName} setValid={setValidFirstName}/>
                    </div>
                    <InputForm value={denomination} setValue={setDenomination} PrimaryText="Dénomination sociale (nom de l'entreprise)" SecondaryText="Dénomination sociale incorrecte"  idInput="inputDenominationPayment" placeHolder="Dénomination sociale" maxLength={120} valid={validDenomination} setValid={setValidDenomination}/>             
                    <InputForm value={address} setValue={setAddress} PrimaryText="Adresse postale de facturation" SecondaryText="Adresse incorrecte"  idInput="inputAddressPayment" placeHolder="Adresse postale" maxLength={120} valid={validAddress} setValid={setValidAddress}/>             
                    <InputForm value={city} setValue={setCity} PrimaryText="Ville de facturation" SecondaryText="Ville incorrecte"  idInput="inputCityPayment" placeHolder="Ville" maxLength={120} valid={validCity} setValid={setValidCity}/>             
                    
                    <div className="containerDobbleInput">
                        <div className="inputPhone">                           
                            <p className="smallTextBold"  style={!validPostalCode ? {color:'red'} : {}}>{ !validPostalCode ? `Le code postal n'est pas valide` : 'Code postal' }</p>
                            <input style={! validPostalCode ? {border:'1px solid red'} : {}} type="text" className="smallText primaryBack" value={currentCode}maxLength={5} onChange={(e) => setCurrentCode(e.target.value)} onBlur={(e) => {setPostalCode(parseInt(e.target.value))}} inputMode="numeric" pattern="\d*"/>
                        </div>
                        <div className="inputPhone">                           
                            <p className="smallTextBold"  style={!validPhone ? {color:'red'} : {}}>{ !validPhone ? `Le numéro de téléphone n'est pas valide` : 'Téléphone' }</p>
                            <input style={! validPhone ? {border:'1px solid red'} : {}} type="text" className="smallText primaryBack" value={phone} onChange={handleChangePhone} onBlur={handleBlurPhone} inputMode="numeric" pattern="\d*"/>
                        </div>
                    </div>

                </div>
                <div className="rightPart smallText">
                    <p className="midTextBold" >Récapitulatif de commande&nbsp;:</p>
                    <div className="containerRecap">   
                        <div className="text"><p>Abonnement mensuel QuelResto</p><p>60 € HT</p></div>
                        <div className="text"><p>TVA</p><p>20 %</p></div>
                        <div className="separation"></div>
                        <div className="text"><p>Total</p><p>72 € TTC</p></div>
                        <div className="text"><p>Remise</p><p>72 €</p></div>
                        <div className="separation"></div>
                        <div className="smallTextBold text"><p>Reste à payer</p><p>0 €</p></div>
                    </div>

                    <i className="XsmallText textEngagment" >Abonnement sans engagement : libre de renouveler ou non à chaque échéance</i>
                    <p className="XsmallText" style={{marginTop:'0px'}}>Après avoir cliqué sur "Passer au paiement", vous serez redirigé vers la plateforme sécurisée Up2Pay, solution de paiement en ligne du Crédit Agricole, afin de finaliser votre transaction en toute sécurité.</p>
                    <p className="midText midGoldButton" onClick={() => {setShowGoPayment(true)}}>Passer au paiement</p>
                
                </div>
                {showGoPayment && <>
                    <div className="containerGoPayment primaryBack smallText">
                        <TfiClose className="close" size={17} onClick={() => {setShowGoPayment(false)}}/>
                        <p className="midTitle">Validation de votre moyen de paiement</p>
                        <p className="firstText ">Une <strong>empreinte bancaire de 1 €</strong> sera affichée lors de l'étape de paiement.</p>
                        <p className=" text">Elle sert uniquement à <strong>vérifier votre carte</strong> et à <strong>activer votre abonnement</strong>.</p>
                        <p className=" text"><strong>Aucun montant ne sera débité</strong> de votre compte.</p>
                        <div className="midText midGoldButton" onClick={handleSubmit}>Passer au paiement</div>
                    </div>
                    <MaskBackground zIndex={14} closeFunction={() => {setShowGoPayment(false)}}/>
                </>
                }
            </div>
           
        </div>
    )
}

export default PagePayement